import {Serializer} from '~/app/core/common/serializers/serializer';
import {Order} from '~/app/core/common/models/Order';

export class OrderSerializer implements Serializer {
    fromJson(json: any): Order {
        const order = new Order();
        order.customerId = json.customerId;
        order.store = json.store;
        order.deliveryDate = json.deliveryDate;
        order.trackingId = json.trackingId;
        order.orderNumber = json.orderNumber;
        order.releaseNumber = json.releaseNumber;
        order.status = json.status;
        order.receiptTotal = json.receiptTotal;
        order.salesTax = json.salesTax;
        order.discount = json.discount;
        order.surcharge = json.surcharge;
        order.receivingStatus = json.receivingStatus;
        return order;
    }

    toJson(resource: Order) {
        return JSON.stringify(resource);
    }

}
